<template>
    <div class="ss-content cultura-activity-detail-content">
        <div class="activity-info">
            <div class="ss-container">
                <div class="activity-info__left">
                    <img :src="articleData.attrs | imgUrl" />
                    <div class="activity-info__num clearfix">
                        <div class="activity-info__item">
                            <span>参与人数</span>
                            <span>{{articleData.regCount | unit}}</span>
                        </div>
                        <div class="activity-info__item">
                            <span>关注人数</span>
                            <span>{{articleData.downs | unit}}</span>
                        </div>
                        <div class="activity-info__item">
                            <span>查看次数</span>
                            <span>{{articleData.views | unit}}</span>
                        </div>
                    </div>
                    <div
                        class="activity-info__btn"
                        v-show="articleData.activityStatus && articleData.activityStatus !== 2"
                    >
                        <button
                            class="btn-primary btn-radius"
                            @click="showModal('regModal', articleData.activityStatus)"
                            :class="{'btn-success' : articleData.activityStatus === 1, 'btn-error' : articleData.activityStatus === 3, 'btn-disabled' : articleData.activityStatus === 4}"
                        >{{activityStatus[articleData.activityStatus]}}</button>
                    </div>
                </div>
                <div class="activity-info__right">
                    <div class="activity-info__title line-1">{{articleData.title}}</div>
                    <div class="activity-info__time">
                        <p v-if="articleData.attrs">活动时间：{{articleData.attrs.startDate}} 至 {{articleData.attrs.endDate}}</p>
                        <p v-if="articleData.place">活动地点：{{articleData.place}}</p>
                    </div>
                    <div class="activity-info__desc">{{articleData.intro}}</div>
                </div>
            </div>
        </div>
        <div class="activity-detail-content ss-container">
            <div class="activity-detail__left ss-container__left">
                <ul class="activity-detail__menu">
                    <li
                        :class="{active: activityIndex === index}"
                        @click="changeActivityIndex(index)"
                        v-for="(item, index) in activityMenu"
                        :key="item.value"
                    >{{item.label}}</li>
                </ul>
                <div class="activity-detail__tab">
                    <div
                        class="activity-detail__content"
                        :class="{'activity-detail__content_active': activityIndex === 0}"
                    >
                        <div v-html="articleData.txt" style="word-break: break-all;"></div>
                    </div>
                    <div
                        class="activity-detail__content publish__content"
                        :class="{'activity-detail__content_active': activityIndex === 1}"
                    >
                        <ssCommentList />
                    </div>
                </div>
            </div>
            <div class="ss-container__right">
                <ss-recmd-list title="热门活动" />
            </div>
        </div>
        <ssActivityRegistration
            ref="regModal"
            :contentId="contentId"
            :notice="(articleData.attrs && articleData.attrs.notice || '')"
        />
    </div>
</template>

<script>
import ssCommentList from '@/components/ss-comment-list/ss-comment-list.vue'
import ssActivityRegistration from '@/components/ss-activity-registration/ss-activity-registration.vue'
import activityDetail from '@/mixins/articleDetail.js'
export default {
    name: 'culturalActivityDetail',
    mixins: [activityDetail],
    components: {
        ssCommentList,
        ssActivityRegistration
    }
    // mounted() {
    //     this.showModal('regModal', this.articleData.activityStatus)
    // }
}
</script>

<style lang="scss" scoped="scoped">
@import '~@/assets/css/activity-detail.scss';
.cultura-activity-detail-content {
    padding-bottom: 70px;
}
</style>
